export enum AggregationTypeEnum {
  Spot = 0,
  Average = 1,
  Low = 2,
  High = 3,
  Tally = 4,
  NoRain = 5,
}
